<template>
  <div class="overlay" v-if="isVisible">
    <div class="adminNewClassPopUp">
      <b class="classSettings">Class Settings</b>
      <div class="frameParent">
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Curriculum
          </div>
          <div class="col-sm-9">
            <hilo-select
              :options="curriculums"
              theme="grey"
              placeholder="Choose One"
              :searchable="true"
              :customStyle="{
                height: '50px',
                width: '100%',
              }"
              v-model="selectedCurriculum"
              @change="updateEndDate"
            ></hilo-select>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Days</div>
          <div class="col-sm-9">
            <div class="daysContainer">
              <div
                class="day"
                v-for="day of days"
                v-bind:key="day.label"
                @click="toggleDay(day)"
                :class="day.dbValue ? 'daySelected' : ''"
              >
                {{ day.label.slice(0, 2) }}
              </div>
            </div>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Class Start
          </div>
          <div class="col-sm-9">
            <input
              type="date"
              placeholder="Date"
              required
              v-model="selectedStartDate"
              @change="updateEndDate"
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Class End</div>
          <div class="col-sm-9">
            <input
              type="date"
              placeholder="Date"
              required
              v-model="selectedEndDate"
              @change="checkIfDisabled"
              disabled
            />
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Preferred Aircraft
          </div>
          <div class="col-sm-9">
            <hilo-select
              :options="aircraft"
              theme="grey"
              placeholder="Choose One"
              :searchable="true"
              :customStyle="{
                height: '50px',
                width: '100%',
              }"
              v-model="selectedAircraft"
              @change="checkIfDisabled"
            ></hilo-select>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">
            Preferred Instructor
          </div>
          <div class="col-sm-9">
            <hilo-select
              :options="instructors"
              theme="grey"
              placeholder="Choose One"
              :searchable="true"
              :customStyle="{
                height: '50px',
                width: '100%',
              }"
              v-model="selectedInstructor"
              @change="checkIfDisabled"
            ></hilo-select>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Students</div>
          <div class="col-sm-9">
            <hilo-select
              :options="students"
              theme="grey"
              placeholder="Select All That Apply"
              :searchable="true"
              :multi-select="true"
              :customStyle="{
                height: '50px',
                width: '100%',
              }"
              v-model="selectedStudents"
              @change="checkIfDisabled"
            ></hilo-select>
          </div>
        </div>
        <div class="row" style="width: 100%">
          <div class="col-sm-3 text-center align-content-center">Comments</div>
          <div class="col-sm-9">
            <input
              type="text"
              placeholder="Comments..."
              required
              v-model="comments"
              @change="checkIfDisabled"
            />
          </div>
        </div>
      </div>
      <div class="row" style="width: 100%">
        <div class="col-sm-12">
          <button
            @click="save"
            class="continueWrapper"
            :disabled="saveDisabled"
          >
            <b class="continue">Continue</b>
          </button>
        </div>
      </div>
      <img
        @click="closeModal"
        class="vectorIcon11"
        alt=""
        src="/static/img/grey-x.svg"
      />
    </div>
    <ToastNotifier ref="toast" />
  </div>
</template>
<script>
import dayjs from "dayjs";
import ToastNotifier from "../../../../components/ToastNotifier.vue";
import HiloSelect from "../../../../components/HiloComponents/HiloSelect.vue";

export default {
  name: "AdminNewClassPopUp",
  components: {
    HiloSelect,
    ToastNotifier,
  },
  props: {
    isVisible: {
      type: Boolean,
      required: true,
    },
    bottomRight: {
      type: Boolean,
      default: false,
    },
    imageViewer: {
      type: Boolean,
      default: false,
    },
    courses: Array,
    instructors: Array,
    students: Array,
    curriculums: Array,
    aircraft: Array,
  },
  data() {
    return {
      days: [
        {
          label: "Sunday",
          dbValue: false,
        },
        {
          label: "Monday",
          dbValue: false,
        },
        {
          label: "Tuesday",
          dbValue: false,
        },
        {
          label: "Wednesday",
          dbValue: false,
        },
        {
          label: "Thursday",
          dbValue: false,
        },
        {
          label: "Friday",
          dbValue: false,
        },
        {
          label: "Saturday",
          dbValue: false,
        },
      ],
      visible: false,
      selectedCurriculum: null,
      selectedStartDate: null,
      selectedEndDate: null,
      selectedAircraft: null,
      selectedInstructor: null,
      selectedStudents: [],
      saveDisabled: true,
      comments: "",
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    save() {
      let temp = {
        classObj: {
          instructorId: this.selectedInstructor,
          startDate: dayjs(this.selectedStartDate),
          curriculumId: this.selectedCurriculum,
          aircraftId: this.selectedAircraft,
          onSunday: this.days[0].dbValue,
          onMonday: this.days[1].dbValue,
          onTuesday: this.days[2].dbValue,
          onWednesday: this.days[3].dbValue,
          onThursday: this.days[4].dbValue,
          onFriday: this.days[5].dbValue,
          onSaturday: this.days[6].dbValue,
          comments: this.comments,
        },
        studentIds: this.selectedStudents,
      };
      this.$emit("save", temp);
      this.selectedStartDate = null;
      this.selectedEndDate = null;
      this.selectedInstructor = null;
      this.selectedCurriculum = null;
      this.selectedAircraft = null;
      this.comments = "";
      this.days = [
        {
          label: "Su",
          dbValue: false,
        },
        {
          label: "Mo",
          dbValue: false,
        },
        {
          label: "Tu",
          dbValue: false,
        },
        {
          label: "We",
          dbValue: false,
        },
        {
          label: "Th",
          dbValue: false,
        },
        {
          label: "Fr",
          dbValue: false,
        },
        {
          label: "Sa",
          dbValue: false,
        },
      ];
      this.selectedStudents = [];
      this.saveDisabled = true;
    },
    checkIfDisabled() {
      this.saveDisabled =
        !this.selectedCurriculum ||
        !this.selectedInstructor ||
        !this.selectedStartDate ||
        !this.selectedEndDate ||
        this.selectedStudents.length === 0 ||
        !this.days.some((data) => data.dbValue);
    },
    toggleDay(day) {
      day.dbValue = !day.dbValue;
      this.$forceUpdate();
      this.updateEndDate();
    },
    updateEndDate() {
      if (
        this.selectedCurriculum &&
        this.selectedStartDate &&
        this.days.some((data) => data.dbValue)
      ) {
        let curriculum = this.curriculums.find(
          (data) => data.id === this.selectedCurriculum,
        );
        let curriculumLength = 0;
        for (let stage of curriculum.curriculumStages) {
          curriculumLength += stage.lessons.length;
        }

        let startDate = dayjs(this.selectedStartDate);

        let selectedDays = [];
        for (let day of this.days) {
          if (day.dbValue) {
            selectedDays.push(day.label);
          }
        }

        let changed = false;
        while (!selectedDays.includes(startDate.format("dddd"))) {
          startDate = startDate.add(1, "day");
          changed = true;
        }

        if (changed) {
          this.$refs.toast.showInfo(
            "Start date changed to match selected days",
          );
        }

        this.selectedStartDate = startDate.format("YYYY-MM-DD");

        let endDate = startDate;

        do {
          if (selectedDays.includes(endDate.format("dddd"))) {
            curriculumLength--;
            if (curriculumLength === 0) break;
          }
          endDate = endDate.add(1, "day");
        } while (curriculumLength > 0);

        this.selectedEndDate = endDate.format("YYYY-MM-DD");
      }
      this.checkIfDisabled();
    },
  },
};
</script>
<style scoped>
.daysContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
}
.day {
  color: #404040;
  opacity: 50%;
  cursor: pointer;
}
.daySelected {
  color: black;
  opacity: 100%;
}
input[type="date"] {
  width: 100%;
  max-width: 1000px;
  padding: 10px;
  font-size: 18px;
  color: #333;
  border: none;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
}

input[type="date"]:invalid::-webkit-datetime-edit {
  color: #9b9b9b;
}

.classSettings {
  position: relative;
  font-size: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 0;
}
.course {
  width: 160px;
  position: relative;
  display: inline-block;
  flex-shrink: 0;
}
.chooseOne {
  position: relative;
}
.vectorIcon {
  width: 13.3px;
  position: relative;
  height: 7.7px;
}
.chooseOneParent {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  box-sizing: border-box;
  color: rgba(64, 64, 64, 0.5);
}
.courseParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
.su {
  position: relative;
  color: rgba(64, 64, 64, 0.5);
}
.suParent {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding: 0px 9px;
  gap: 51px;
  font-size: 15px;
}
.daysParent {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
}
.dateParent {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  box-sizing: border-box;
}
.frameGroup {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  color: rgba(64, 64, 64, 0.5);
}
.commentsWrapper {
  flex: 1;
  border-radius: 10px;
  background-color: rgba(64, 64, 64, 0.05);
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 20px;
  box-sizing: border-box;
  color: rgba(64, 64, 64, 0.5);
}
.frameParent {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  z-index: 1;
}
.continue {
  position: relative;
  display: -webkit-inline-box;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.continueWrapper {
  width: 100%;
  align-self: stretch;
  border-radius: 5px;
  background-color: #3171e2;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
  color: #fff;
  border: none;
  font-size: 18px;
}
.continueWrapper:disabled {
  opacity: 50%;
  cursor: not-allowed;
}
.vectorIcon11 {
  width: 12px;
  position: absolute;
  margin: 0 !important;
  top: 39px;
  right: 51px;
  height: 12px;
  z-index: 3;
  cursor: pointer;
}
.adminNewClassPopUp {
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  box-sizing: border-box;
  gap: 20px;
  text-align: left;
  font-size: 18px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
  margin: auto;
}
.overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 50;
}
</style>
